/* eslint-disable max-len */
import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../components/AdminModal';
import useToast from '../../../customHooks/useToast';
import { DELETE_KAABO_COUPON } from '../../../graphql/admin_mutations';
import InfoIconNew from '../../../svgs/InfoIconNew';

interface IDeleteCouponModal {
  coupon: any;
  closeModal: () => void;
  refetch: () => void;
}

const DeleteCouponModal = ({ coupon, closeModal, refetch }: IDeleteCouponModal) => {
  const Toast = useToast();
  const [done, setDone] = useState(false);
  const [permanentDelete, { loading }] = useMutation(DELETE_KAABO_COUPON);

  const handleSubmit = async () => {
    try {
      const res = await permanentDelete({ variables: { couponId: coupon.id } });
      if (res.data?.deleteCoupon?.status === 200) {
        setDone(true);
        refetch();
      } else {
        Toast.error(res.data?.deleteCoupon?.message || 'Delete failed');
      }
    } catch (e: any) {
      Toast.error(e?.graphQLErrors?.[0]?.message || 'Something went wrong');
    }
  };

  return (
    <AdminModal
      headText={done ? 'Coupon removed' : 'Delete coupon permanently?'}
      subText={
        done ? (
          <span>This coupon code has been removed from the system.</span>
        ) : (
          <span>
            This cannot be undone. Code
            {' '}
            <strong>{coupon?.couponCode}</strong>
            {' '}
            will stop working immediately.
          </span>
        )
      }
      actionBtnName={done ? 'Close' : 'Delete permanently'}
      handleModalAction={done ? closeModal : handleSubmit}
      topIcon={<InfoIconNew />}
      isShow
      isSuccess={done}
      isActionBtnDisabled={loading}
      onClickAway={() => {}}
      onClose={closeModal}
      isLoading={loading}
    />
  );
};

export default DeleteCouponModal;
